export interface Sticker {
  id: string;
  name: string;
  ext?: string;
  animation?: "bounce" | "wiggle" | "spin" | "pulse" | "shake" | "pop";
}

export interface StickerPack {
  id: string;
  name: string;
  thumbnail: string; // The sticker id used as the pack's thumbnail/icon
  stickers: Sticker[];
}

export const STICKER_PACKS: StickerPack[] = [
  {
    id: "memoji_apple",
    name: "Apple Memoji",
    thumbnail: "thumbs_up",
    stickers: [
      { id: "thumbs_up", name: "Thumbs Up" },
      { id: "heart_eyes", name: "Heart Eyes" },
      { id: "sunglasses", name: "Sunglasses" },
      { id: "mind_blown", name: "Mind Blown" },
    ],
  },
  {
    id: "boss",
    name: "Boss",
    thumbnail: "thumbs_up",
    stickers: [
      { id: "thumbs_up", name: "Thumbs Up", animation: "bounce" },
      { id: "heart_eyes", name: "Heart Eyes", animation: "pulse" },
      { id: "flower_face", name: "Flower Face", animation: "pop" },
      { id: "pensive", name: "Pensive", animation: "pulse" },
      { id: "big_belly", name: "Big Belly", animation: "bounce" },
      { id: "laughing", name: "Laughing", animation: "bounce" },
      { id: "surprised", name: "Surprised", animation: "pop" },
      { id: "waving", name: "Waving", animation: "wiggle" },
      { id: "angry", name: "Angry", animation: "shake" },
      { id: "crying", name: "Crying", animation: "wiggle" },
      { id: "ok_sign", name: "OK", animation: "bounce" },
      { id: "thinking", name: "Thinking", animation: "pulse" },
      { id: "working", name: "Working", animation: "wiggle" },
      { id: "cheers", name: "Cheers", animation: "bounce" },
      { id: "sleeping", name: "Sleeping", animation: "pulse" },
    ],
  },
  {
    id: "cute_cat",
    name: "Cute Cat",
    thumbnail: "wave",
    stickers: [
      { id: "wave", name: "Waving Cat", animation: "wiggle" },
      { id: "love", name: "Loving Cat", animation: "pulse" },
      { id: "cry", name: "Crying Cat", animation: "wiggle" },
      { id: "laugh", name: "Laughing Cat", animation: "bounce" },
      { id: "sleeping", name: "Sleeping Cat", animation: "pulse" },
      { id: "scared", name: "Scared Cat", animation: "pop" },
      { id: "heart_eyes", name: "Heart Eyes Cat", animation: "pulse" },
      { id: "thumbs_up", name: "Thumbs Up Cat", animation: "bounce" },
    ],
  },
  {
    id: "cute_dog",
    name: "Cute Dog",
    thumbnail: "excited",
    stickers: [
      { id: "excited", name: "Excited Dog", animation: "bounce" },
      { id: "sad", name: "Sad Dog", animation: "wiggle" },
      { id: "cool", name: "Cool Dog", animation: "pulse" },
      { id: "angry", name: "Angry Dog", animation: "shake" },
      { id: "sleeping", name: "Sleeping Dog", animation: "pulse" },
      { id: "heart_eyes", name: "Heart Eyes Dog", animation: "pulse" },
      { id: "crying", name: "Crying Dog", animation: "wiggle" },
      { id: "thumbs_up", name: "Thumbs Up Dog", animation: "bounce" },
    ],
  },
  {
    id: "cool_monkey",
    name: "Cool Monkey",
    thumbnail: "excited",
    stickers: [
      { id: "see", name: "See No Evil" },
      { id: "hear", name: "Hear No Evil" },
      { id: "speak", name: "Speak No Evil" },
      { id: "excited", name: "Excited Monkey" },
    ],
  },
  {
    id: "cute_bunny",
    name: "Cute Bunny",
    thumbnail: "wink",
    stickers: [
      { id: "wink", name: "Winking Bunny" },
      { id: "shy", name: "Shy Bunny" },
      { id: "sleepy", name: "Sleepy Bunny" },
      { id: "heart", name: "Loving Bunny" },
    ],
  },
  {
    id: "pikalong_dragon",
    name: "Pikalong Cute Dragon",
    thumbnail: "hello",
    stickers: [
      { id: "hello", name: "Pikalong Hello", animation: "wiggle" },
      { id: "love", name: "Pikalong Love", animation: "pulse" },
      { id: "sad", name: "Pikalong Sad", animation: "bounce" },
      { id: "excited", name: "Pikalong Excited", animation: "pop" },
    ],
  },
  {
    id: "qoobee_dragon",
    name: "QooBee Agapi",
    thumbnail: "smile",
    stickers: [
      { id: "smile", name: "QooBee Smile", animation: "bounce" },
      { id: "giggle", name: "QooBee Giggle", animation: "wiggle" },
      { id: "sad", name: "QooBee Sad", animation: "pulse" },
      { id: "coffee", name: "QooBee Coffee", animation: "pop" },
    ],
  },
  {
    id: "ami_cat",
    name: "Ami Fat Cat",
    thumbnail: "hello",
    stickers: [
      { id: "hello", name: "Ami Hello", animation: "wiggle" },
      { id: "love", name: "Ami Love", animation: "pulse" },
      { id: "cry", name: "Ami Cry", animation: "bounce" },
      { id: "excited", name: "Ami Excited", animation: "pop" },
    ],
  },
  {
    id: "brown_bear",
    name: "Chubby Brown Bear",
    thumbnail: "hello",
    stickers: [
      { id: "hello", name: "Bear Hello", animation: "wiggle" },
      { id: "love", name: "Bear Love", animation: "pulse" },
      { id: "sad", name: "Bear Sad", animation: "bounce" },
      { id: "excited", name: "Bear Excited", animation: "pop" },
    ],
  },
  {
    id: "pepe_frog",
    name: "Pepe Frog",
    thumbnail: "smile",
    stickers: [
      { id: "smile", name: "Pepe Smile", animation: "wiggle" },
      { id: "cry", name: "Pepe Cry", animation: "bounce" },
      { id: "angry", name: "Pepe Angry", animation: "shake" },
      { id: "cool", name: "Pepe Cool", animation: "pop" },
    ],
  },
  {
    id: "mochi_cat",
    name: "Mochi Peach Cat",
    thumbnail: "hello",
    stickers: [
      { id: "hello", name: "Mochi Hello", animation: "wiggle" },
      { id: "love", name: "Mochi Love", animation: "pulse" },
      { id: "sad", name: "Mochi Sad", animation: "bounce" },
      { id: "excited", name: "Mochi Excited", animation: "pop" },
    ],
  },
  {
    id: "db_super",
    name: "Dragon Ball Super",
    thumbnail: "goku_hello",
    stickers: [
      { id: "goku_hello", name: "Goku Hello", animation: "wiggle" },
      { id: "vegeta_angry", name: "Vegeta Angry", animation: "shake" },
      { id: "goku_kame", name: "Goku Kamehameha", animation: "pulse" },
      { id: "buu_eat", name: "Majin Buu Eating", animation: "bounce" },
    ],
  },
  {
    id: "db_epic",
    name: "Dragon Ball Legend",
    thumbnail: "goku_ui",
    stickers: [
      { id: "goku_ui", name: "Goku UI", animation: "pulse" },
      { id: "vegeta_ue", name: "Vegeta UE", animation: "shake" },
      { id: "beerus", name: "Beerus Destruction", animation: "pop" },
      { id: "gogeta_blue", name: "Gogeta Blue", animation: "bounce" },
    ],
  },
  {
    id: "db_goku",
    name: "Goku (Dragon Ball)",
    thumbnail: "hello",
    stickers: [
      { id: "hello", name: "Goku Hello", animation: "wiggle" },
      { id: "thumbs_up", name: "Goku Thumbs Up", animation: "bounce" },
      { id: "kame", name: "Goku Kamehameha", animation: "pulse" },
      { id: "ui_glare", name: "Goku Ultra Instinct", animation: "pulse" },
      { id: "angry", name: "Goku Angry", animation: "shake" },
      { id: "eating", name: "Goku Eating", animation: "bounce" },
      { id: "exhausted", name: "Goku Exhausted", animation: "wiggle" },
      { id: "instant_transmission", name: "Instant Transmission", animation: "pop" },
      { id: "spirit_bomb", name: "Spirit Bomb", animation: "pulse" },
      { id: "laughing", name: "Goku Laughing", animation: "bounce" },
    ],
  },
  {
    id: "db_vegeta",
    name: "Vegeta (Dragon Ball)",
    thumbnail: "thumbs_up",
    stickers: [
      { id: "smirk", name: "Vegeta Smirk", animation: "wiggle" },
      { id: "angry", name: "Vegeta Angry", animation: "shake" },
      { id: "ultra_ego", name: "Vegeta Ultra Ego", animation: "pulse" },
      { id: "final_flash", name: "Final Flash", animation: "pulse" },
      { id: "thumbs_up", name: "Vegeta Salute", animation: "bounce" },
      { id: "defeated", name: "Vegeta Defeated", animation: "wiggle" },
      { id: "shocked", name: "Vegeta Shocked", animation: "pop" },
      { id: "blushing", name: "Vegeta Blushing", animation: "wiggle" },
      { id: "glare", name: "Vegeta Glare", animation: "pulse" },
      { id: "charging", name: "Vegeta Charging", animation: "shake" },
    ],
  },
  {
    id: "db_beerus",
    name: "Beerus (Dragon Ball)",
    thumbnail: "smug",
    stickers: [
      { id: "yawn", name: "Beerus Yawn", animation: "wiggle" },
      { id: "ramen", name: "Beerus Eating Ramen", animation: "bounce" },
      { id: "hakai", name: "Beerus Hakai", animation: "pulse" },
      { id: "smug", name: "Beerus Smug", animation: "wiggle" },
      { id: "sleeping", name: "Beerus Sleeping", animation: "pulse" },
      { id: "angry", name: "Beerus Angry", animation: "shake" },
      { id: "shocked", name: "Beerus Shocked", animation: "pop" },
      { id: "bored", name: "Beerus Bored", animation: "wiggle" },
      { id: "eating_pudding", name: "Beerus Eating Pudding", animation: "bounce" },
      { id: "mocking", name: "Beerus Mocking", animation: "pop" },
    ],
  },
  {
    id: "db_goku_black",
    name: "Goku Black (Dragon Ball)",
    thumbnail: "tea",
    stickers: [
      { id: "tea", name: "Goku Black Tea", animation: "wiggle" },
      { id: "rose_blade", name: "Goku Black Rosé", animation: "pulse" },
      { id: "sinister_smile", name: "Sinister Smile", animation: "wiggle" },
      { id: "divine_wrath", name: "Divine Wrath", animation: "pulse" },
      { id: "angry", name: "Goku Black Angry", animation: "shake" },
      { id: "glare", name: "Goku Black Glare", animation: "pulse" },
      { id: "pain", name: "Goku Black Pain", animation: "wiggle" },
      { id: "cloning", name: "Goku Black Scythe", animation: "pop" },
      { id: "confident", name: "Goku Black Confident", animation: "bounce" },
      { id: "pointing", name: "Goku Black Pointing", animation: "pulse" },
    ],
  },
  {
    id: "db_hit",
    name: "Hit (Dragon Ball)",
    thumbnail: "calm",
    stickers: [
      { id: "calm", name: "Hit Calm", animation: "wiggle" },
      { id: "time_skip", name: "Hit Time Skip", animation: "pulse" },
      { id: "glare", name: "Hit Glare", animation: "pulse" },
      { id: "fight_stance", name: "Hit Fight Stance", animation: "shake" },
      { id: "adjusting_coat", name: "Hit Adjusting Coat", animation: "wiggle" },
      { id: "serious", name: "Hit Serious", animation: "wiggle" },
      { id: "assassin", name: "Hit Flash Fist", animation: "pulse" },
      { id: "injured", name: "Hit Injured", animation: "wiggle" },
      { id: "closed_eyes", name: "Hit Meditating", animation: "wiggle" },
      { id: "smirk", name: "Hit Rare Smirk", animation: "bounce" },
    ],
  },
  {
    id: "db_jiren",
    name: "Jiren (Dragon Ball)",
    thumbnail: "crossed_arms",
    stickers: [
      { id: "crossed_arms", name: "Jiren Crossed Arms", animation: "wiggle" },
      { id: "glare", name: "Jiren Glare", animation: "pulse" },
      { id: "power_up", name: "Jiren Power Up", animation: "shake" },
      { id: "punching", name: "Jiren Punching", animation: "shake" },
      { id: "meditation", name: "Jiren Meditation", animation: "wiggle" },
      { id: "fireball", name: "Jiren Fireball", animation: "pulse" },
      { id: "screaming", name: "Jiren Screaming", animation: "shake" },
      { id: "shield", name: "Jiren Barrier", animation: "pop" },
      { id: "stoic", name: "Jiren Stoic", animation: "wiggle" },
      { id: "unfazed", name: "Jiren Unfazed", animation: "bounce" },
    ],
  },
  {
    id: "db_frieza",
    name: "Frieza (Dragon Ball)",
    thumbnail: "golden_pose",
    stickers: [
      { id: "evil_laugh", name: "Frieza Evil Laugh", animation: "bounce" },
      { id: "golden_pose", name: "Golden Frieza", animation: "pulse" },
      { id: "smirk", name: "Frieza Smirk", animation: "wiggle" },
      { id: "death_ball", name: "Death Ball", animation: "pulse" },
      { id: "furious", name: "Frieza Furious", animation: "shake" },
      { id: "mocking", name: "Frieza Mocking", animation: "bounce" },
      { id: "shocked", name: "Frieza Shocked", animation: "pop" },
      { id: "kicked", name: "Frieza Pain", animation: "wiggle" },
      { id: "telekinesis", name: "Telekinesis", animation: "pulse" },
      { id: "sinister_glare", name: "Sinister Glare", animation: "wiggle" },
    ],
  },
  {
    id: "db_gohan",
    name: "Gohan (Dragon Ball)",
    thumbnail: "study",
    stickers: [
      { id: "study", name: "Gohan Studying", animation: "wiggle" },
      { id: "beast_scream", name: "Gohan Beast", animation: "shake" },
      { id: "masenko", name: "Gohan Masenko", animation: "pulse" },
      { id: "happy", name: "Gohan Happy", animation: "bounce" },
      { id: "mystic_glare", name: "Ultimate Gohan", animation: "pulse" },
      { id: "fight_stance", name: "Gohan Fighting", animation: "shake" },
      { id: "shocked", name: "Gohan Shocked", animation: "pop" },
      { id: "crying", name: "Gohan Crying", animation: "wiggle" },
      { id: "thumbs_up", name: "Gohan Thumbs Up", animation: "bounce" },
      { id: "protective", name: "Gohan Protective", animation: "pulse" },
    ],
  },
  {
    id: "db_piccolo",
    name: "Piccolo (Dragon Ball)",
    thumbnail: "crossed_arms",
    stickers: [
      { id: "meditate", name: "Piccolo Meditating", animation: "wiggle" },
      { id: "special_beam", name: "Special Beam Cannon", animation: "pulse" },
      { id: "orange_power", name: "Orange Piccolo", animation: "shake" },
      { id: "crossed_arms", name: "Piccolo Crossed Arms", animation: "wiggle" },
      { id: "cape_throw", name: "Cape Throw", animation: "pop" },
      { id: "angry", name: "Piccolo Angry", animation: "shake" },
      { id: "smirk", name: "Piccolo Smirk", animation: "wiggle" },
      { id: "regeneration", name: "Regeneration", animation: "pulse" },
      { id: "surprised", name: "Piccolo Surprised", animation: "pop" },
      { id: "paternal", name: "Piccolo Proud", animation: "wiggle" },
    ],
  },
  {
    id: "db_bulma",
    name: "Bulma (Dragon Ball)",
    thumbnail: "radar",
    stickers: [
      { id: "radar", name: "Bulma Radar", animation: "wiggle" },
      { id: "angry", name: "Bulma Angry", animation: "shake" },
      { id: "happy", name: "Bulma Happy", animation: "bounce" },
      { id: "thinking", name: "Bulma Thinking", animation: "wiggle" },
      { id: "shocked", name: "Bulma Shocked", animation: "pop" },
      { id: "smirk", name: "Bulma Smirk", animation: "wiggle" },
      { id: "sigh", name: "Bulma Sigh", animation: "wiggle" },
      { id: "scared", name: "Bulma Scared", animation: "pop" },
      { id: "drinking", name: "Bulma Coffee", animation: "bounce" },
      { id: "waving", name: "Bulma Waving", animation: "bounce" },
    ],
  },
  {
    id: "db_trunks",
    name: "Future Trunks (Dragon Ball)",
    thumbnail: "sword_ready",
    stickers: [
      { id: "sword_ready", name: "Trunks Sword Ready", animation: "pulse" },
      { id: "rage_scream", name: "Super Saiyan Rage", animation: "shake" },
      { id: "burning_attack", name: "Burning Attack", animation: "pulse" },
      { id: "sad", name: "Trunks Sad", animation: "wiggle" },
      { id: "happy", name: "Trunks Happy", animation: "bounce" },
      { id: "fight_stance", name: "Trunks Fighting", animation: "shake" },
      { id: "sword_slash", name: "Sword Slash", animation: "pulse" },
      { id: "shocked", name: "Trunks Shocked", animation: "pop" },
      { id: "determined", name: "Trunks Determined", animation: "wiggle" },
      { id: "salute", name: "Trunks Salute", animation: "bounce" },
    ],
  },
  {
    id: "db_android17",
    name: "Android 17 (Dragon Ball)",
    thumbnail: "ranger",
    stickers: [
      { id: "ranger", name: "Ranger 17", animation: "wiggle" },
      { id: "shield", name: "Android Barrier", animation: "pulse" },
      { id: "calm", name: "Android 17 Calm", animation: "wiggle" },
      { id: "angry", name: "Android 17 Angry", animation: "shake" },
      { id: "happy", name: "Android 17 Happy", animation: "bounce" },
      { id: "fight", name: "Android 17 Fighting", animation: "shake" },
      { id: "injured", name: "Android 17 Injured", animation: "wiggle" },
      { id: "wink", name: "Android 17 Wink", animation: "pop" },
      { id: "barrier_blast", name: "Barrier Blast", animation: "pulse" },
      { id: "meditating", name: "Android 17 Meditating", animation: "wiggle" },
    ],
  },
  {
    id: "db_android18",
    name: "Android 18 (Dragon Ball)",
    thumbnail: "hair_flip",
    stickers: [
      { id: "hair_flip", name: "Android 18 Hair Flip", animation: "wiggle" },
      { id: "happy", name: "Android 18 Happy", animation: "bounce" },
      { id: "fight", name: "Android 18 Fighting", animation: "shake" },
      { id: "glare", name: "Android 18 Glare", animation: "pulse" },
      { id: "wink", name: "Android 18 Wink", animation: "pop" },
      { id: "bored", name: "Android 18 Bored", animation: "wiggle" },
      { id: "angry", name: "Android 18 Angry", animation: "shake" },
      { id: "shopping", name: "Android 18 Shopping", animation: "bounce" },
      { id: "injured", name: "Android 18 Injured", animation: "wiggle" },
      { id: "meditating", name: "Android 18 Meditating", animation: "wiggle" },
    ],
  },
  {
    id: "db_krillin",
    name: "Krillin (Dragon Ball)",
    thumbnail: "destructo_disk",
    stickers: [
      { id: "destructo_disk", name: "Destructo Disk", animation: "pulse" },
      { id: "fight", name: "Krillin Fighting", animation: "shake" },
      { id: "solar_flare", name: "Solar Flare", animation: "pulse" },
      { id: "happy", name: "Krillin Happy", animation: "bounce" },
      { id: "shocked", name: "Krillin Shocked", animation: "pop" },
      { id: "injured", name: "Krillin Injured", animation: "wiggle" },
      { id: "kamehameha", name: "Krillin Kamehameha", animation: "pulse" },
      { id: "love", name: "Krillin Love", animation: "bounce" },
      { id: "serious", name: "Krillin Serious", animation: "pulse" },
      { id: "zen", name: "Krillin Meditating", animation: "wiggle" },
    ],
  },
  {
    id: "db_roshi",
    name: "Master Roshi (Dragon Ball)",
    thumbnail: "peace",
    stickers: [
      { id: "peace", name: "Roshi Peace", animation: "bounce" },
      { id: "fight", name: "Roshi Fighting", animation: "shake" },
      { id: "buff", name: "Roshi Max Power", animation: "pulse" },
      { id: "nosebleed", name: "Roshi Nosebleed", animation: "bounce" },
      { id: "kamehameha", name: "Roshi Kamehameha", animation: "pulse" },
      { id: "laughing", name: "Roshi Laughing", animation: "bounce" },
      { id: "wink", name: "Roshi Wink", animation: "pop" },
      { id: "peace_v2", name: "Roshi Cool", animation: "bounce" },
      { id: "thinking", name: "Roshi Thinking", animation: "wiggle" },
      { id: "sleeping", name: "Roshi Sleeping", animation: "wiggle" },
    ],
  },
  {
    id: "db_zamasu",
    name: "Zamasu (Dragon Ball)",
    thumbnail: "sinister",
    stickers: [
      { id: "sinister", name: "Zamasu Sinister", animation: "pulse" },
      { id: "god_stance", name: "Zamasu God Stance", animation: "wiggle" },
      { id: "holy_wrath", name: "Holy Wrath", animation: "pulse" },
      { id: "fusion_prep", name: "Potara Fusion Prep", animation: "pop" },
      { id: "tears", name: "Holy Tears", animation: "wiggle" },
      { id: "shocked", name: "Zamasu Shocked", animation: "shake" },
      { id: "blade", name: "Zamasu Ki Blade", animation: "shake" },
      { id: "laughing", name: "Zamasu Laughing", animation: "bounce" },
      { id: "injured", name: "Zamasu Corrupted", animation: "shake" },
      { id: "happy", name: "Zamasu Smug", animation: "bounce" },
    ],
  },
  {
    id: "db_whis",
    name: "Whis (Dragon Ball)",
    thumbnail: "eating",
    stickers: [
      { id: "eating", name: "Whis Eating", animation: "bounce" },
      { id: "laughing", name: "Whis Laughing", animation: "bounce" },
      { id: "shocked", name: "Whis Shocked", animation: "pop" },
      { id: "calm", name: "Whis Calm", animation: "wiggle" },
      { id: "wink", name: "Whis Wink", animation: "pop" },
      { id: "pointing", name: "Whis Pointing", animation: "wiggle" },
      { id: "yawning", name: "Whis Yawning", animation: "wiggle" },
      { id: "dodging", name: "Whis Dodging", animation: "shake" },
      { id: "sleeping", name: "Whis Sleeping", animation: "wiggle" },
      { id: "sushi", name: "Whis Sushi", animation: "bounce" },
      { id: "tea", name: "Whis Tea", animation: "bounce" },
    ],
  },
  {
    id: "db_shin",
    name: "Shin (Dragon Ball)",
    thumbnail: "shocked",
    stickers: [
      { id: "shocked", name: "Shin Shocked", animation: "shake" },
      { id: "fight", name: "Shin Fighting", animation: "shake" },
      { id: "telekinesis", name: "Shin Telekinesis", animation: "pulse" },
      { id: "happy", name: "Shin Happy", animation: "bounce" },
      { id: "scared", name: "Shin Scared", animation: "shake" },
      { id: "thinking", name: "Shin Thinking", animation: "wiggle" },
      { id: "potara", name: "Shin Potara", animation: "pop" },
      { id: "katchin", name: "Shin Katchin", animation: "bounce" },
      { id: "angry", name: "Shin Angry", animation: "shake" },
      { id: "zen", name: "Shin Meditating", animation: "wiggle" },
    ],
  },
];



